import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { getFeatureFlags } from './functions'
import { FeatureFlagsResponse } from './types'

const flags = {
    // refetchInterval only added in root component (App.tsx), not in other consumers to avoid duplication
    GetFeatureFlags: {
        useQuery: <TData = FeatureFlagsResponse>(options?: Omit<UseQueryOptions<FeatureFlagsResponse, AxiosError, TData>, 'queryKey' | 'queryFn'>) =>
            useQuery({
                queryKey: ['feature-flags'],
                queryFn: getFeatureFlags,
                ...options,
            }),
    },
}

export default flags
